module.exports = __webpack_public_path__ + "655f2fe42f907aeaa23c2f1da7636cb4.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/content/assets/2093_teaser_image.jpg
// module id = 593
// module chunks = 0